"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthTokenHandlerBase = void 0;
const AlmeAuthorizationApiBase_1 = require("./AlmeAuthorizationApiBase");
class AuthTokenHandlerBase {
    constructor(logger, httpHandler, settings) {
        this.AuthorizationApi = new AlmeAuthorizationApiBase_1.AlmeAuthorizationApiBase(logger, httpHandler, settings);
        this.AuthSettings = settings;
        this.AuthToken = null;
    }
    async SetClientSecret(storage, clientSecret) {
        this.ClientSecret = clientSecret;
        //get new token from Alme or load saved token.
        await this.checkTokenExpiration(storage);
    }
    async getToken(storage) {
        if (!this.ClientSecret) {
            return null;
        }
        //call auth api to get token
        const authRequest = { ClientSecret: this.ClientSecret };
        const response = await this.AuthorizationApi.PostAuthorizationAsync(authRequest);
        if (response) {
            const token = {
                token: response,
                expiresAt: this.getExpirationDateTime(response.ExpiresIn),
            };
            //save token to storage
            this.AuthToken = token;
            return storage.UpdateStorage(token) || null;
        }
        return null;
    }
    async checkTokenExpiration(storage) {
        //check expiration and get new token if needed
        let token = storage === null || storage === void 0 ? void 0 : storage.GetStorage();
        const currentTime = Date.now();
        if (!token || token.expiresAt <= currentTime) {
            token = await this.getToken(storage);
        }
        if (!token) {
            return;
        }
        this.AuthToken = token;
        let authTokenExpireCheck = token.expiresAt - currentTime;
        if (authTokenExpireCheck <= 0) {
            authTokenExpireCheck = 0;
        }
        //restart timeout
        setTimeout(() => { void this.checkTokenExpiration(storage); }, authTokenExpireCheck);
    }
    getExpirationDateTime(expireSeconds) {
        return Date.now() + ((expireSeconds - this.AuthSettings.AlmeAuthorizationExpireBufferSeconds) * 1000);
    }
    AddAuthHeader(requestInit) {
        if (this.AuthToken && this.AuthToken.token.TokenType && this.AuthToken.token.Token && requestInit) {
            if (requestInit.headers) {
                const newHeaders = new Headers(requestInit.headers);
                newHeaders.append('Authorization', `${this.AuthToken.token.TokenType} ${this.AuthToken.token.Token}`);
                requestInit.headers = newHeaders;
            }
            else {
                requestInit.headers = { 'Authorization': `${this.AuthToken.token.TokenType} ${this.AuthToken.token.Token}` };
            }
        }
    }
}
exports.AuthTokenHandlerBase = AuthTokenHandlerBase;
//# sourceMappingURL=AuthTokenHandlerBase.js.map